import React from 'react';
import { useSearchParams } from 'react-router-dom';

import ApplicationsTable from '../Components/SectionsForUsersPage/ApplicationsTable';
import ApparatusSROTable from '../Components/SectionsForUsersPage/ApparatusSROTable';
import ArbitrationManagersTable from '../Components/SectionsForUsersPage/ArbitrationManagersTable';
import DeactivatedAccountsTable from '../Components/SectionsForUsersPage/DeactivatedAccountsTable';
import SearchUsers from '../Components/SearchModals/SearchUsers';

import HeadlinePanel from '../Components/HeadlinePanel';

import styles from '../styles/TableContainers.module.css';
import headerPanel from '../styles/HeaderPanel.module.css';
import subpageSelection from '../styles/SubpageSelection.module.css';

export default function Users() {
    const [isSearch, setIsSearch] = React.useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const table = searchParams.get('table') || 'arbitration-managers';

    React.useEffect(() => {
        if (window.location.hash === '#search') {
            setIsSearch(true);
        }
    }, []);

    return (
    <>
        {isSearch && <SearchUsers closeModal={() => {window.location.hash = ''; setIsSearch(false)}} type={''} />}

        <div className='mainContainer'>
            <HeadlinePanel label='Пользователи' type='' />
            <div className='containerInner'>
                <div className={subpageSelection.panel}>
                    <a onClick={() => setSearchParams({ table: 'arbitration-managers' })} className={`${subpageSelection.buttonToSubPages} ${table === 'arbitration-managers' ? subpageSelection.active : ''}`}>Список регионов и арбитражных управляющих</a>
                    <a onClick={() => setSearchParams({ table: 'apparatus-sro' })} className={`${subpageSelection.buttonToSubPages} ${table === 'apparatus-sro' ? subpageSelection.active : ''}`}>Список работников Аппарата СРО</a>
                    <a onClick={() => setSearchParams({ table: 'applications' })} className={`${subpageSelection.buttonToSubPages} ${table === 'applications' ? subpageSelection.active : ''}`}>Заявки</a>
                    <a onClick={() => setSearchParams({ table: 'deactivated-accounts' })} className={`${subpageSelection.buttonToSubPages} ${table === 'deactivated-accounts' ? subpageSelection.active : ''}`}>Деактивированные учётные записи</a>
                </div>
                <div className={headerPanel.additionalPanel}>
                    <div className={headerPanel.searchBtn} onClick={() => { window.location.hash = 'search'; setIsSearch(true) }}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z" /></svg>
                        Поиск...
                    </div>
                </div>
                {table == 'arbitration-managers'? <ArbitrationManagersTable />
                : table == 'apparatus-sro' ? <ApparatusSROTable />
                : table == 'applications' ? <ApplicationsTable />
                : table == 'deactivated-accounts'? <DeactivatedAccountsTable />
                : <a className={styles.initialState}>Выберите страницу</a>}
            </div>
        </div>
    </>
    )
}
